import { injectable } from "../injection";
import { windowAsAny } from "../windowAsAny/windowAsAny";

@injectable("singleton")
export class AppTimerService {
    private startTime = 0;

    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (windowAsAny().redDeerAppStartTime) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            this.startTime = windowAsAny().redDeerAppStartTime;
        } else {
            this.startTime = Date.now();
        }
    }

    public timeInMs() {
        return Date.now() - this.startTime;
    }
}
